<template>
  <div class="w-64">
    <TextField
      class="my-4 text-sm"
      type="text"
      v-model="form.name"
      placeholder="Name"
      @keyup.stop.prevent.esc="cancel"
      @keydown.stop.prevent.esc="cancel"
      @keyup.native.enter="save"
      focus-on-mount
      size="sm"
      :errors="(errors.name || [])"
    />
    <div>
      <Button @click="save" size="sm" class="w-16">
        {{ shortlist ? 'Update' : 'Add' }}
      </Button>
      <Button @click="cancel" size="sm" class="w-16">Cancel</Button>
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import Button from 'components/common/Button'
import TextField from 'components/forms/TextField'
import { useShortlists } from '@/states/shortlists/useShortlists'

export default {
  components: {
    Button,
    TextField,
  },
  props: {
    organizationId: String,
    shortlist: Object,
  },
  setup(props, { emit }) {
    const { createShortlist, updateShortlist, errors } = useShortlists()

    const getInitialData = () => ({
      name: props.shortlist ? props.shortlist.name : '',
    })
    const form = ref(getInitialData())

    const save = async () => {
      console.log(' => save()', form.value)
      const { name } = form.value
      const data = { name }
      if (props.organizationId) {
        data.organizationId = props.organizationId
      }
      if (props.shortlist && props.shortlist.id) {
        data.id = props.shortlist.id
        await updateShortlist(data)
        emit('update', data)
      } else {
        const response = await createShortlist(data)
        emit('create', response.data)
      }
    }
    const cancel = () => {
      emit('cancel')
    }

    return {
      form,

      save,
      cancel,
      errors,
    }
  },
}
</script>
